import { all, call } from 'redux-saga/effects';
import loginSagas from './auth/sagas';
import appSagas from './app/sagas';
import userSagas from './user/sagas';
import regSagas from './registration/sagas';
import memberSaga from './members/sagas';
import addMemberSaga from './member/sagas';
import impersonateUserSagas from './iuser/sagas';
import referralChannelsSagas from './channels/sagas';
import lodgeEnquirySagas from './lodgeEnquiry/sagas';
import areaOfInterestSagas from './areaOfInterest/sagas';
import enquiriesSagas from './enquiries/sagas';
import mapSagas from './map/sagas';
import organisationUserSagas from './organisation/sagas';
import ReportsSagas from './reports/sagas';
import ReferralsSagas from './referrals/sagas';
import dashboardSagas from './dashboard/sagas';
import emergencyContactsSagas from './emergencyContacts/sagas';
import webhookSagas from './webhook/sagas';
import ArcgisSagas from './arcgis/sagas';
import AnnouncementsSagas from './announcement/sagas';
import emailSagas from './emails/sagas';
import cloSagas from './clo/sagas';
import responseSagas from './response/sagas';
import AuthorisationsSagas from './authorisation/sagas';
import webLauncherLandingSagas from './webLauncherLanding/sagas';
import safetyMessageAndLogoSagas from './safetyMessageAndLogo/sagas';
import trackSagas from './track/sagas';
import autodeskSagas from './autodesk/sagas';
import memberLookupSagas from './bydaMemberLookup/sagas';
import belSagas from './bulkEnquiryLodgement/sagas';
import paymentSagas from './payment/sagas';

export default function* rootSaga() {
  yield all([
    call(appSagas),
    call(loginSagas),
    call(regSagas),
    call(userSagas),
    call(memberSaga),
    call(addMemberSaga),
    call(impersonateUserSagas),
    call(referralChannelsSagas),
    call(lodgeEnquirySagas),
    call(mapSagas),
    call(organisationUserSagas),
    call(areaOfInterestSagas),
    call(enquiriesSagas),
    call(ReportsSagas),
    call(ReferralsSagas),
    call(dashboardSagas),
    call(emergencyContactsSagas),
    call(webhookSagas),
    call(ArcgisSagas),
    call(AnnouncementsSagas),
    call(emailSagas),
    call(cloSagas),
    call(AuthorisationsSagas),
    call(webLauncherLandingSagas),
    call(responseSagas),
    call(safetyMessageAndLogoSagas),
    call(autodeskSagas),
    call(trackSagas),
    call(memberLookupSagas),
    call(belSagas),
    call(paymentSagas)
  ]);
}
